import { useState } from 'react';
import useSWR from 'swr';

import SubmitScorecardEditor from './SubmitScorecardEditor';
import paperAirplane from 'assets/icon-paper-airplane-green.svg';
import axios from 'axios';

import LoadingSpinner from 'components/loadingSpinner';
import { useLocation } from 'react-router-dom';

export default function SubmitScorecardContainer() {
  const [submitted, setSubmitted] = useState(false);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const signature = searchParams.get('signature');

  const fetcher = (url) =>
    axios
      .get(url)
      .then((response) => response.data)
      .catch((error) => error.response?.data);

  const { data } = useSWR(`/api/submitscorecard/?signature=${signature}`, fetcher, {
    revalidateOnFocus: false,
  });

  const isLoading = data === undefined;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // For some reason, I wasn't able to implement proper error handling with swr.
  // I hacked together a solution to return the error instead and it works fine.
  // We'll probably want to add the correct error handling at some point but for
  // now, this will have to do.
  const { candidate, custom_scorecard, role_title, error } = data;

  let statusMessage = null;
  if (submitted) {
    statusMessage = 'Scorecard submitted!';
  } else if (error === 404) {
    statusMessage = 'Scorecard already submitted';
  } else if (error === 'Expired signature') {
    statusMessage = 'Oops, the time limit for this link has expired. Please request a new link.';
  } else if (error === 'Reference not found.') {
    statusMessage = 'This reference request has been removed.';
  } else if (error === 400) {
    statusMessage = 'Invalid scorecard link, please request a new link';
  }

  if (statusMessage) {
    return (
      <center style={{ marginTop: 100 }}>
        {submitted && <img src={paperAirplane} alt="" />}
        <h2 className="mt1">{statusMessage}</h2>
      </center>
    );
  }

  return (
    <div
      style={{
        padding: '50px',
        maxWidth: '990px',
        margin: 'auto',
      }}
    >
      <h3 className="mb2">{`${candidate} - ${role_title}`}</h3>
      <SubmitScorecardEditor
        customScorecard={custom_scorecard}
        setSubmitted={setSubmitted}
        location={location}
      />
    </div>
  );
}
